module.exports = __webpack_public_path__ + "img/veggie-burger.c954a5c2.png";